export const TOOLTIP_COPY =
  'Saving a backup allows you to restore your wallet if you ever lose access. ' +
  'Without a backup, Pixeloop cannot guarantee recovery of your funds.'

export const BANNER_TITLE = 'Wallet backup recommended'
export const BANNER_BODY =
  'Create a wallet backup to help restore access if you lose your account. ' +
  'Without a backup, Pixeloop cannot guarantee recovery of your funds.'

export const WALLET_BACKUP_DISMISS_KEY_LEGACY = 'wallet:backup-banner:dismissed'
export const WALLET_BACKUP_DISMISS_KEY_PREFIX = 'pixeloop.wallet.backupDismissed.v1'

export function walletBackupDismissKey(userId: number | string): string {
  return `${WALLET_BACKUP_DISMISS_KEY_PREFIX}:${String(userId)}`
}

export function hasConfirmedBackup(backupConfirmedAt?: string | null): boolean {
  return Boolean(backupConfirmedAt)
}

export function shouldShowBackupBanner(opts: {
  hasSummary: boolean
  walletEnabled: boolean
  view: 'wallet' | 'buy'
  backupConfirmedAt?: string | null
  dismissed: boolean
}): boolean {
  if (!opts.hasSummary) return false
  if (!opts.walletEnabled) return false
  if (opts.view !== 'wallet') return false
  if (hasConfirmedBackup(opts.backupConfirmedAt)) return false
  return !opts.dismissed
}

export function readBackupBannerDismissed(
  userId: number | string | null | undefined,
  storage: Pick<Storage, 'getItem'> = localStorage
): boolean {
  if (userId === null || userId === undefined || userId === '') return false
  try {
    const key = walletBackupDismissKey(userId)
    const current = storage.getItem(key) === '1'
    if (current) return true
    // Backward compatibility: migrate old non-user-scoped dismissal key.
    return storage.getItem(WALLET_BACKUP_DISMISS_KEY_LEGACY) === '1'
  } catch {
    return false
  }
}

export function writeBackupBannerDismissed(
  userId: number | string | null | undefined,
  storage: Pick<Storage, 'setItem'> = localStorage
): boolean {
  if (userId === null || userId === undefined || userId === '') return false
  try {
    storage.setItem(walletBackupDismissKey(userId), '1')
    return true
  } catch {
    return false
  }
}
